<nb-card>
  <nb-card-header>
    Bitte geben Sie Ihren PIN ein, um auf das Gebäude zuzugreifen
  </nb-card-header>

  <nb-card-body>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <input
        nbInput
        placeholder="PIN"
        formControlName="pin"
        type="password"
        class="pin-login"
      />

      <button nbButton status="primary" type="submit" class="submit-button" [disabled]="form.invalid">
        Bestätigen
      </button>
    </form>
  </nb-card-body>
</nb-card>
